export interface Person_Tahsili_Interface {
  id:number,
  person_id:number,
  date_starrt:String,
  date_end:String,
  degree:String,
  reshteh:String,
  grayesh:String,
  uni:String,
  moadel:String,
  image:String,
}

export function Empty_Person_Tahsili_Interface(){
  return{
    id:0,
    person_id:0,
    date_starrt:'',
    date_end:'',
    degree:'',
    reshteh:'',
    grayesh:'',
    uni:'',
    moadel:'',
    image:'',
  }
}

